import {extractModuleIdentifiers, ModuleNode} from '@backstage-components/base';
import {FC} from 'react';
import {BackgroundVideoComponent} from './BackgroundVideoComponent';
import {SchemaType} from './BackgroundVideoDefinition';
import {Box} from '@chakra-ui/react';

export type BackgroundVideoProps = SchemaType;

export const BackgroundVideoPreviewComponent: FC<
  ModuleNode<'BackgroundVideo', BackgroundVideoProps>
> = (definition) => {
  const {props} = definition.module;
  const {slotComponent: Slot} = definition;
  return (
    <Box padding={10} position="relative" overflow="hidden">
      <Box
        position="absolute"
        top="0"
        left="0"
        pointerEvents="none"
        w="100%"
        h="100%"
        zIndex={1}
      >
        <BackgroundVideoComponent
          component={definition.module.component}
          config={{scope: 'admin'}}
          {...extractModuleIdentifiers(definition.module)}
          props={props}
        />
      </Box>
      <Box position="relative" zIndex={2}>
        <Slot slotName="items" />
      </Box>
    </Box>
  );
};
